<!--
/**
* @name: List.vue
* @description: app广告位配置列表页面
* @author: 杨波
* @create: 2020/08/17 14:06:58
* @update: 2020/08/17 14:06:58
*/
-->

<template>
  <y-view :loading="isLoading">
    <div slot="left" class="left-panel">
      <k-tree :data="treeDataList" hasActions class="mt-1" searchField="typeName" v-model="editPara.advertPositionTypeId" selectedRule="some" keyField="id">
        <div slot-scope="{ item }" :class="css.tree_item">
          <div>{{ item.typeName }}</div>
          <div v-if="item.typeName == '全部广告位'" :class="css.item_action"><a href="javascript:void(0);" @click="onAddTree">新增</a></div>
          <div v-else :class="css.item_action"><a href="javascript:void(0);" @click="onEditTree(item.typeName)">编辑</a></div>
        </div>
      </k-tree>
    </div>
    <div class="right-content">
      <y-query :hasSearchButton="false" spaceBetween>
        <y-query-item>
          <k-input placeholder="请输入关键字" clearable v-model="para.positionName"></k-input>
        </y-query-item>
        <y-query-item>
          <k-button type="primary" @click="onSearch">查询</k-button>
        </y-query-item>
        <y-query-item>
          <k-button @click="onReset">重置</k-button>
        </y-query-item>
        <y-query-item slot="right">
          <y-button icon="k-icon-add" :disabled="editPara.advertPositionTypeId == 0 ? true : false" @click="addAdPosition">新建</y-button>
        </y-query-item>
      </y-query>
      <k-table :data="positionList" :height="$root.tableHeightX" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
      <k-pagination :total="total" v-if="positionList && positionList.length > 0" :current-page.sync="para.pageCurrent" :page-size.sync="para.pageSize" @page-change="onChangePageIndex" />
    </div>
    <!-- 新增广告位区域 -->
    <div class="popup_box">
      <k-popup bind="v-if" okText="提交" :title="isEdit ? '编辑广告位' : '新增广告位'" :show.sync="isPopupShow" @after-ok="onSave">
        <div style="width: 650px;">
          <y-form titleAlign="right" titleWidth="100px" contentWidth="250px">
            <y-form-item title="销售渠道:" required>
              <k-select placeholder="请选择销售渠道" block clearable v-model="editPara.saleChannelCode">
                <k-option v-for="item in channelList" :key="item.code" :value="item.code" :label="item.name" :selected="editPara.saleChannelCode == item.code">{{ item.name }}</k-option>
              </k-select>
            </y-form-item>
            <y-form-item title="广告位名称:" required>
              <k-input placeholder="请输入广告位名称" v-model="editPara.positionName" clearable v-validate="'required|minLength(2)|maxLength(20)'" block maxlength="20"></k-input>
            </y-form-item>
            <y-form-item title="适用客户端:" required>
              <div>
                <k-checkbox type="arr" :data-arr.sync="editPara.suitClients" value="APP" text="app端"></k-checkbox>
                <k-checkbox type="arr" :data-arr.sync="editPara.suitClients" value="SMALL" text="小程序端"></k-checkbox>
              </div>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div>
    <!-- 新增广告位区域 end -->
    <!-- 新增广告位类别区域 -->
    <div class="popup_box">
      <k-popup bind="v-if" okText="提交" :title="isEditPosotion ? '编辑广告位类别' : '新增广告位类别'" :show.sync="isPopupTypeShow" @after-ok="onTypeSave">
        <div style="width: 650px;">
          <y-form titleAlign="right" titleWidth="100px" contentWidth="250px">
            <y-form-item title="广告位类别名称:" required>
              <k-input placeholder="请输入广告位类别名称" clearable v-model="typeName" v-validate="'required|minLength(2)|maxLength(20)'" block maxlength="20"></k-input>
            </y-form-item>
          </y-form>
        </div>
      </k-popup>
    </div>
    <!-- 新增广告位类别区域 end -->
  </y-view>
</template>

<script>
import {
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_LIST,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_SAVE,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_PAGE,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_ENABLED,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DISABLED,
  NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_SAVE,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_UPDATE,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DETAIL,
  NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_UPDATE,
} from "@/assets/modules/apiList";
const initPara = () => ({
  positionName: "",
  advertPositionTypeId: "",
  pageCurrent: 1,
  pageSize: 15,
});
const initEditPara = () => ({
  advertPositionTypeId: "",
  positionName: "",
  saleChannelCode: "",
  suitClients: [],
});
export default {
  data() {
    return {
      isPopupShow: false,
      isPopupTypeShow: false,
      isLoading: false,
      typeName: "",
      para: initPara(),
      editPara: initEditPara(),
      isSaving: false,
      treeDataList: [
        {
          id: 0,
          pid: 0,
          typeName: "全部广告位",
          childs: [],
          __open__: true,
        },
      ],
      suitClientsList: [
        {
          Id: "APP",
          Name: "app端",
        },
        {
          Id: "SMALL",
          Name: "小程序端",
        },
      ],
      positionList: [],
      channelList: [],
      isEdit: false,
      isEditPosotion: false,
      total: 0,
      originData: {},
    };
  },
  watch: {
    "editPara.advertPositionTypeId": {
      handler(newName, oldName) {
        this.getPositionList();
      },
      immediate: true,
    },
  },
  methods: {
    onAddTree() {
      this.isPopupTypeShow = true;
    },
    onEditTree(name) {
      this.typeName = name;
      this.isEditPosotion = true;
      this.isPopupTypeShow = true;
    },
    initColumns() {
      return [
        {
          name: "广告位ID",
          field: "id",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "广告位名称",
          field: "positionName",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "适用客户端",
          field: "suitClientsStr",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "销售渠道",
          field: "saleChannelName",
          style: {
            textAlign: "center",
          },
        },
        {
          name: "启用状态",
          field: "",
          style: {
            textAlign: "center",
          },
          customRender: (row) => (
            <k-switch
              checked={row.isEnabled}
              readonly
              onClick={() => {
                this.onChangeStatus(row);
              }}
            />
          ),
        },

        {
          name: "操作",
          field: "",
          style: {
            textAlign: "center",
          },
          customRender: (row) => {
            const configButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onConfig(row);
                }}
              >
                配置
              </a>
            );
            const editButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onEdit(row);
                }}
              >
                编辑
              </a>
            );
            return (
              <div>
                {configButton}&#12288;{editButton}
              </div>
            );
          },
        },
      ];
    },
    onSearch() {
      this.para.pageCurrent = 1;
      this.getPositionList();
    },
    onReset() {
      this.para = initPara();
      this.getPositionList();
    },
    onEdit(row) {
      this.isEdit = true;
      this.getPosDetail(row.id);
      this.isPopupShow = true;
    },
    getPosDetail(id) {
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DETAIL,
        para: { id: id },
      }).then((res) => {
        this.originData = JSON.parse(JSON.stringify(res));
        res.suitClients = res.suitClients.split(",");
        this.editPara = res;
      });
    },
    onSave() {
      const { tip } = this.$root;
      if (this.isSaving) {
        return;
      }
      let para = JSON.parse(JSON.stringify(this.editPara));
      this.isSaving = true;
      this.isLoading = false;
      para.suitClients = para.suitClients.join(",");
      this.$fetch({
        api: this.isEdit ? NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_UPDATE : NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_SAVE,
        para,
      })
        .then((res) => {
          this.isSaving = false;
          this.isLoading = false;
          tip("操作成功");
          this.getPositionList();
          this.isPopupShow = false;
        })
        .catch(() => {
          this.isSaving = false;
          this.isLoading = false;
        });
    },
    addAdPosition() {
      this.isEdit = false;
      this.isPopupShow = true;
      this.editPara.positionName = "";
      this.editPara.saleChannelCode = "";
      this.editPara.suitClients = [];
    },
    getChannelList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_SALE_CHANNEL_LIST,
        para: {},
      }).then((res) => {
        this.channelList = res || [];
      });
    },
    onChangeStatus(row) {
      let { id, isEnabled } = row;
      this.$dialog({
        title: "提示",
        content: `是否确认${row.isEnabled ? "停用" : "启用"}该广告位？`,
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: row.isEnabled ? NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_DISABLED : NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_ENABLED,
            para: { id },
          })
            .then(() => {
              this.isLoading = false;
              this.getPositionList();
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onChangePageIndex(p) {
      this.para.pageCurrent = p;
      this.getPositionList();
    },
    getTypeList() {
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_LIST,
        para: {},
      }).then((res) => {
        this.treeDataList[0].childs = res;
      });
    },
    getPositionList() {
      let { para } = this;
      para.advertPositionTypeId = this.editPara.advertPositionTypeId ? this.editPara.advertPositionTypeId : "";
      this.$fetch({
        api: NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_PAGE,
        para,
      }).then((res) => {
        let data = res.pageList;
        data.forEach((item) => {
          let suitClientsList = item.suitClients.split(",");
          let suitClientsStr = [];
          suitClientsList.forEach((tt) => {
            if (tt == "APP") {
              suitClientsStr.push("APP");
            }
            if (tt == "SMALL") {
              suitClientsStr.push("小程序");
            }
          });
          item.suitClientsStr = suitClientsStr.join(",");
        });
        this.positionList = res.pageList;
        this.total = res.total;
      });
    },
    onTypeSave() {
      const { tip } = this.$root;
      this.$fetch({
        api: this.isEditPosotion ? NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_UPDATE : NESTLE_MARKETING_BACK_SERVER_ADVERT_POSITION_TYPE_SAVE,
        para: { id: this.editPara.advertPositionTypeId, typeName: this.typeName },
      }).then((res) => {
        tip("广告位类型保存成功");
        this.getTypeList();
        this.isPopupTypeShow = false;
      });
    },
    onConfig(row) {
      const { id, positionName } = row;
      this.$controller.open({
        name: "advertiseConfig",
        query: {
          refresh: new Date() - 0,
          id,
          positionName,
        },
      });
    },
  },
  created() {
    this.getTypeList();
    this.getPositionList();
    this.getChannelList();
  },
};
</script>

<style lang="postcss" module="css">
.search_key {
  width: 160px;
}
.tree_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  & .item_action {
    display: none;
  }
  &:hover .item_action {
    display: block;
    animation: fade 0.3s linear;
  }
}
@keyframes fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
